module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-06.6fac5128.jpg";